import { useUnitsPreference, UnitSystem } from '@/hooks/use-units-preference';
import React, { createContext, useContext } from 'react';

interface UnitsContextValue {
  units: UnitSystem;
  setUnits: (units: UnitSystem) => Promise<void>;
  toggleUnits: () => Promise<void>;
}

const UnitsContext = createContext<UnitsContextValue | undefined>(undefined);

export function UnitsProvider({ children }: { children: React.ReactNode }) {
  const { units, setUnits, toggleUnits } = useUnitsPreference();

  const contextValue: UnitsContextValue = {
    units,
    setUnits,
    toggleUnits,
  };

  return (
    <UnitsContext.Provider value={contextValue}>
      {children}
    </UnitsContext.Provider>
  );
}

export function useUnits(): UnitSystem {
  const context = useContext(UnitsContext);
  if (!context) {
    throw new Error('useUnits must be used within UnitsProvider');
  }
  return context.units;
}

export function useUnitsControl() {
  const context = useContext(UnitsContext);
  if (!context) {
    throw new Error('useUnitsControl must be used within UnitsProvider');
  }
  return {
    units: context.units,
    setUnits: context.setUnits,
    toggleUnits: context.toggleUnits,
  };
}
